import type { Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';
import { Color } from 'shared/utils/colors';

export const notApplicableToggleRootSx = {
  ml: 'auto',
  mr: 0,
  flexShrink: 0,
  boxSizing: 'border-box',
  height: 28,
  minHeight: 28,
  maxHeight: 28,
  px: 1.5,
  py: 0,
  borderRadius: 999,
  display: 'inline-flex',
  alignItems: 'center',
  textTransform: 'none',
  fontSize: '0.75rem',
  fontWeight: 600,
  lineHeight: 1,
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none',
  },
  '& .MuiButton-startIcon': {
    mr: 0.75,
    ml: 0,
    display: 'inline-flex',
    alignItems: 'center',
  },
  '&.MuiButton-root': {
    height: 28,
    minHeight: 28,
    maxHeight: 28,
    py: 0,
  },
  '& .MuiButton-startIcon > svg': {
    fontSize: 16,
    width: 16,
    height: 16,
  },
} satisfies SystemStyleObject<Theme>;

export const notApplicableToggleStaticSx = {
  cursor: 'default',
  gap: 0.75,
  userSelect: 'none',
} satisfies SystemStyleObject<Theme>;

export const notApplicableToggleIconSx = {
  fontSize: 16,
  width: 16,
  height: 16,
  display: 'block',
} satisfies SystemStyleObject<Theme>;

export const notApplicableToggleIdleSx = {
  backgroundColor: Color.white,
  border: `1px solid ${Color.border}`,
  color: Color.black,
  '&:hover': {
    backgroundColor: Color.primaryOrangeHover,
    borderColor: Color.border,
  },
  '&.Mui-disabled': {
    backgroundColor: Color.white,
    borderColor: Color.border,
    color: Color.mutedBlack,
  },
} satisfies SystemStyleObject<Theme>;

export const notApplicableToggleSkippedSx = {
  backgroundColor: Color.primaryOrangePale,
  border: `1px solid ${Color.primaryOrange}`,
  color: Color.textActive,
  '&:hover': {
    backgroundColor: Color.primaryOrangePale,
    borderColor: Color.primaryOrange,
  },
} satisfies SystemStyleObject<Theme>;
